/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, FC, useContext, useEffect, useRef, useState } from "react";

import { MAP_TYPES } from "./constant";
import useIsDesktop from "hooks/useIsDesktop";
import getParsedLocalStorageData from "@Components/LeadFormModal/helpers/getParsedLocalStorageData";
import { isEmptyObject } from "helpers/validations";

const defaultLocationContextValue: any = {
  map: null,
  center: null,
  universities: null,
  selectedUniversity: null,
  mapType: MAP_TYPES.ROAD_VIEW,
  nearbyLocation: null,
  distance: null,
  nearbyLocations: null,
  nearbyLocationMarkers: null,
  inventoryMarker: null,
  regionMarker: {},
  regionSearchValue: null,
  showDistanceCard: null,
  setMap: () => {},
  setCenter: () => {},
  setUniversities: () => {},
  setSelectedUniversity: () => {},
  setMapType: () => {},
  setNearbyLocation: () => {},
  setDistance: () => {},
  setRegionSearchValue: () => {},
  setShowDistanceCard: () => {},
};

export const LocationContext = createContext<any>(defaultLocationContextValue);

export const LocationProvider: FC<any> = ({ children }) => {
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(null);
  const [universities, setUniversities] = useState<any[] | null>([]);
  const [selectedUniversity, setSelectedUniversity] = useState<any | null>(null);
  const [selectedUniversityFromLocal, setSelectedUniversityFromLocal] = useState<any | null>(null);
  const [mapType, setMapType] = useState<any>(MAP_TYPES.ROAD_VIEW);
  const [nearbyLocation, setNearbyLocation] = useState<any>({});
  const [distance, setDistance] = useState<any>({});
  const [regionSearchValue, setRegionSearchValue] = useState<any>();
  const [queryUniversityData, setQueryUniversityData] = useState<any>();
  const [showDistanceCard, setShowDistanceCard] = useState<boolean>(false);

  const nearbyLocations = useRef([]);
  const nearbyLocationMarkers = useRef([]);
  const regionMarker = useRef(null);
  const inventoryMarker = useRef(null);
  const isDesktop = useIsDesktop();
  const isDesktopStreetView = isDesktop && mapType === MAP_TYPES.STREET_VIEW;

  useEffect(() => {
    const uni = getParsedLocalStorageData("filtered_university_and_region");
    setSelectedUniversityFromLocal(isEmptyObject(uni) ? null : uni);
  }, []);

  return (
    <LocationContext.Provider
      value={{
        map,
        setMap,
        center,
        setCenter,
        universities,
        setUniversities,
        selectedUniversity,
        setSelectedUniversity,
        queryUniversityData,
        setQueryUniversityData,
        mapType,
        setMapType,
        nearbyLocation,
        setNearbyLocation,
        distance,
        setDistance,
        nearbyLocations,
        nearbyLocationMarkers,
        regionMarker,
        inventoryMarker,
        regionSearchValue,
        setRegionSearchValue,
        isDesktopStreetView,
        selectedUniversityFromLocal,
        setSelectedUniversityFromLocal,
        showDistanceCard,
        setShowDistanceCard,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => useContext<any>(LocationContext);
